import React, { Component } from 'react';
import ValidationError from './validation_error';

class RadioButtonInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.selectedOption || undefined,
    };
  }

  handleOptionChange = (changeEvent) => {
    const { value } = changeEvent.target;
    this.setState({
      selectedOption: value,
    });

    this.props.onChange(value === 'Yes');
  };

  render() {
    const { options, name, errors } = this.props;
    const { selectedOption } = this.state;

    return (
      <div>
        <div className={`about-you__radio-group about-you__${name}`}>
          {options.map((option, index) => (
            <div key={index} className="about-you__radio-group__item">
              <label style={{ display: 'flex', alignItems: 'center' }} key={index}>
                <input
                  type="radio"
                  name={name}
                  value={option}
                  checked={selectedOption === option}
                  onChange={this.handleOptionChange}
                />
                {option}
              </label>
            </div>
          ))}
        </div>
        <ValidationError version="2" errors={errors} />
      </div>
    );
  }
}

export default RadioButtonInput;
